import { render, staticRenderFns } from "./ApprovedLeasesTabScreen.vue?vue&type=template&id=08670a28&"
import script from "./ApprovedLeasesTabScreen.vue?vue&type=script&lang=js&"
export * from "./ApprovedLeasesTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08670a28')) {
      api.createRecord('08670a28', component.options)
    } else {
      api.reload('08670a28', component.options)
    }
    module.hot.accept("./ApprovedLeasesTabScreen.vue?vue&type=template&id=08670a28&", function () {
      api.rerender('08670a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/screens/LeasesScreen/ApprovedLeasesTabScreen.vue"
export default component.exports